import {
  adminDangerButtonStyle,
  adminPrimaryButtonStyle,
} from "./adminFormStyles";

const footerPrimaryButtonStyle = {
  ...adminPrimaryButtonStyle,
  minHeight: "2.75rem",
};

const footerDangerButtonStyle = {
  ...adminDangerButtonStyle,
  minHeight: "2.75rem",
};

interface AdminDrawerFooterProps {
  mode: "create" | "edit";
  confirmDelete: boolean;
  isPending: boolean;
  submitLabel: string;
  deleteLabel?: string;
  confirmDeleteLabel?: string;
  submitDisabled?: boolean;
  primaryClassName?: string;
  dangerClassName?: string;
  onSubmit: () => void;
  onCancel?: () => void;
  onRequestDelete?: () => void;
  onConfirmDelete?: () => void;
}

export function AdminDrawerFooter({
  mode,
  confirmDelete,
  isPending,
  submitLabel,
  deleteLabel = "Excluir",
  confirmDeleteLabel = "Confirmar exclusão",
  submitDisabled = false,
  primaryClassName,
  dangerClassName,
  onSubmit,
  onCancel,
  onRequestDelete,
  onConfirmDelete,
}: AdminDrawerFooterProps) {
  return (
    <div style={{ display: "flex", gap: "0.75rem", marginTop: "1.5rem" }}>
      {onCancel ? (
        <button
          style={{
            ...footerPrimaryButtonStyle,
            background: "transparent",
            border: "1px solid var(--login-border)",
            color: "var(--login-text)",
          }}
          onClick={onCancel}
          disabled={isPending}
          type="button"
        >
          Cancelar
        </button>
      ) : null}
      {mode === "edit" && !confirmDelete && onRequestDelete ? (
        <button
          className={dangerClassName}
          style={footerDangerButtonStyle}
          onClick={onRequestDelete}
          disabled={isPending}
          type="button"
        >
          {deleteLabel}
        </button>
      ) : null}
      {mode === "edit" && confirmDelete && onConfirmDelete ? (
        <button
          className={dangerClassName}
          style={footerDangerButtonStyle}
          onClick={onConfirmDelete}
          disabled={isPending}
          type="button"
        >
          {confirmDeleteLabel}
        </button>
      ) : null}
      <button
        className={primaryClassName}
        style={footerPrimaryButtonStyle}
        onClick={onSubmit}
        disabled={isPending || submitDisabled}
        type="button"
      >
        {submitLabel}
      </button>
    </div>
  );
}
